<template>
<basic-container>
    <basic-container>
    <el-form ref="searchForm" :model="query" label-width="80px" margin-top="0">
        

      <el-row>
        <el-col :span="6">
          <el-form-item label="小区" prop="propertyId" label-width="100px">
              
            <el-select v-model="query.communityId" @change="communityChange" style="width: 100%;">
              <el-option
                style="padding-left: 10px;"
                v-for="item in communityList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="6">
          <el-form-item label="计费资源类型" label-width="100px">
            <el-select v-model="query.targetResourceType" style="width: 100%;" @change="targetResourceTypeChange">
              <el-option
                style="padding-left: 10px;"
                v-for="item in targetResourceTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="计费对象">



                  
            <el-select
              :value="targetName"
              ref="propertySelectRef1"
              placeholder="请选择计费对象"
              style="width: 100%;"
              clearable
              @clear="clearProperty"
            >
            
                  <!-- :data="treeData" -->
              <el-option :value="targetName" :label="propertyName">
                <el-tree
                  v-if="showTagetTreeFlag"
                  ref="propertyTreeRef1"
                  node-key="id"
                  :props="treeProps"
                  :load="lazyLoadPropertyTree"
                  lazy
                  @node-click="propertyNodeTreeClick1"
                >
                </el-tree>
              </el-option>
            </el-select>


            <!-- <el-select v-model="query.targetResourceType" style="width: 100%;" clearable>
              <el-option
                style="padding-left: 10px;"
                v-for="item in targetResourceTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >

              </el-option>
            </el-select> -->


          </el-form-item>
        </el-col>


        <el-col :span="6">
          <el-form-item label="收费科目">
            <el-select v-model="query.subjectId" style="width: 100%;" @change="subjectChangeHandler" clearable>
              <el-option
                style="padding-left: 10px;"
                v-for="item in subjectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="6">
            <el-form-item label="收费标准名称" label-width="100px">
              <el-select v-model="query.standardId" style="width: 100%;" clearable>
                  <el-option
                  style="padding-left: 10px;"
                  v-for="item in searchForm.standardList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
        </el-col>
        
        <el-col :span="6">
          <el-form-item label="计费时间" label-width="100px">
            <el-date-picker
              style="width: 100%;" 
              v-model="query.dateRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss" 
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      
          <el-col :span="12" style="text-align:right">
            <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
            <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
          </el-col>
      </el-row>


      <el-row>
      </el-row>
      <el-row>
      </el-row>
    </el-form>
    <avue-crud
      v-if="showAvueCrudFlag"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :before-open="beforeOpen"
      
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >

      <template slot-scope="scope" slot="menuLeft">
          <el-button
          type="primary"
          size="small"
          icon="el-icon-add"
          @click="showAddBox(scope.row)"
          >
              新增
          </el-button>
          <el-button
          type="primary"
          size="small"
          icon="el-icon-delete"
          @click="unBindList()"
          >
              批量解绑
          </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
          <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="viewData(scope.row)"
          >
              查看
          </el-button>
          <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="unBind(scope.row)"
          >
              解绑
          </el-button>
      </template>
      <template slot="targetResourceType" slot-scope="scope">
        <div>{{getTargetResourceType(scope.row.targetResourceType)}}</div>
      </template>
      <template slot="cycle" slot-scope="scope">
        <div>{{handleShowCycle(scope.row)}}</div>
      </template>
      <!-- <template slot="subjectId" slot-scope="scope">
        <div>{{getSubjectId(scope.row.subjectId)}}</div>
      </template> -->
    </avue-crud>
  </basic-container>

<el-dialog

      title="新增"
      :visible.sync="showRoomSelect"
      width="80%"
      custom-class="room-select-dialog"
      append-to-body
      center
      @close="showRoomSelect = false"

>
  <div>
    <div>
      
      <el-steps :active="activeStep" align-center>
        <el-step title="第一步" description="选择收费标准"></el-step>
        <el-step title="第二步" description="选择收费对象"></el-step>
        <el-step title="第三步" description="校验是否重复"></el-step>
      </el-steps>
    </div>
    <div>

      <div v-if="formStepOneFlag">
        <div style="padding:1rem 0;font-weight:bold;">收费标准</div> 
        <el-form label-width="80px">
          <el-form-item label="费用科目">
              <el-select v-model="formStepOne.subjectId" @change="subjectChangeHandler_" style="width: 100%;" clearable>
                  <el-option
                    style="padding-left: 10px;"
                    v-for="item in subjectList_"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="收费标准">
              <el-select v-model="formStepOne.standardId" @change="standardChange" style="width: 100%;" clearable>
                  <el-option
                    style="padding-left: 10px;"
                    v-for="item in searchForm.standardList_"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="生效时间">
            <el-input disabled v-model="standardDetail.startTime"></el-input>
          </el-form-item>
          <el-form-item label="失效时间">
            <el-input disabled v-model="standardDetail.endTime"></el-input>
          </el-form-item>
          <el-form-item label="标准说明">
            <el-input disabled v-model="standardDetail.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="toStepTwo">下一步</el-button>
            <el-button @click="showRoomSelect = false">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <div v-if="formStepTwoFlag">
        <div style="padding:1rem 0;font-weight:bold;">资源范围</div> 
        <el-form label-width="80px">
          <el-form-item label="资源类型">
              <el-select v-model="formStepTwo.targetResourceType" style="width: 100%;" clearable>
                  <el-option
                    style="padding-left: 10px;"
                    v-for="item in targetResourceTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="">
            <div style="border:1px solid #ccc;height:30vh;overflow:scroll;" v-loading="bindTreeLoading">
                
                    <!-- :load="lazyLoadPropertyTree"
                    check-strictly
                    lazy -->
                  <el-tree
                    show-checkbox
                    default-expand-all
                    v-if="showTagetTreeFlag"
                    :data="treeData"
                    ref="standardTreeRef"
                    node-key="id"
                    @node-expand="nodeExpandHandler"
                    @check-change="nodeCheckChange"
                    :default-checked-keys="defaultKeys"
                    :props="treeProps"
                    @check="nodeTreeCheckClick1"
                    @node-click="propertyNodeTreeClick1"
                  >
              </el-tree>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="backStepOne">上一步</el-button>
            <el-button @click="toStepThree">下一步</el-button>
            <el-button @click="showRoomSelect = false">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="formStepThreeFlag">
        <div style="padding:1rem 0;font-weight:bold;">绑定确认</div> 
        <el-table
          :data="formStepThreeTableList">
              <el-table-column prop="targetName" label="计费对象"></el-table-column>
              <el-table-column prop="targetResourceType" label="计费资源类型">
                <template slot-scope="sp">
                  {{getTargetResourceType(sp.row.targetResourceType)}}
                </template>
              </el-table-column>
              <el-table-column prop="subjectId" label="费用科目">
                <template slot-scope="sp">
                  {{getSubjectId(sp.row.subjectId)}}
                </template>
              </el-table-column>
              <el-table-column prop="standardId" label="收费标准名称">
                <template slot-scope="sp">
                  {{getStandardId(sp.row.standardId)}}
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="开始计费时间"></el-table-column>
              <el-table-column prop="endTime" label="开始计费时间"></el-table-column>
        </el-table>
        <div style="padding:1rem 0;">
            <el-button @click="finishBind">完成</el-button>
            <el-button @click="showRoomSelect = false">返回</el-button>
        </div>
      </div>




    </div>
  </div>
</el-dialog>
<el-dialog>

</el-dialog>
  </basic-container>
</template>

<script>
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
import { loadRoomTree2,loadRoomTree1 } from '@/api/common/room-select';
import { checkTreeBind,getAreaZoneList,getStandardPageList,getSubjectList,getStandardList,removeStandard,getStandardDetail,getBindKeys,batchBind,getLazyBasePropertyTree } from '@/api/v4ward/bindstandard/bindstandard'
import { getList } from '@/api/v4ward/offlinepay/offLineSum';
import { mapGetters } from 'vuex';
import { getDictionary } from '../../../api/common';
import {
  getDict
} from '@/api/v4ward/fee-standard/index';

var DIC = {
  PAYTYPE: [
    {
      label: '微信',
      value: 'W',
    },
    {
      label: '支付宝',
      value: 'A',
    },
  ],
};
export default {
  data() {
    return {
      showAvueCrudFlag:false,
      activeStep:'1',
      formStepOneFlag:true,
      formStepTwoFlag:false,
      formStepThreeFlag:false,
      formStepThreeTableList:[],
      showTagetTreeFlag:false,
      showAreaZoneTreeFlag:false,
      formStepOne:{
        targetResourceType:'',
        standardId:''
      },
      formStepTwo:{
        targetResourceType:'',
      },
      showRoomSelect:false,
      communityId:'',
      targetName:'',
      communityList:[],
      form: {},
      query: {
        standardId:'',
      },
      loading: true,
      saveBtn: false,
      showSummary: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      payTypeList: DIC.PAYTYPE,
      feeTypeParamList: [],
      option: {
        menuPosition: 'center',
        align: 'center',
        height: '400',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        menu: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: true,
        column: [
          {
            label: '计费对象',
            minWidth: 150,
            prop: 'targetName',
          },
          {
            label: '计费资源类型',
            slot:true,
            prop: 'targetResourceType',
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=fee_resource_type',
                props: {
                    label: 'dictValue',
                    value: 'dictKey',
                },
                dataType: 'number',
          },
          
        //   {
        //     label: '计费面积',
        //     prop: 'feeTypeParam',
        //     hide: true,
        //   },
          {
            label: '计费客户',
            prop: 'customer',
          },
          // {
          //   label: '收费科目',
          //   prop: 'subjectId',
          //   slot: true
          // },
          {
            label: '收费科目',
            prop: 'subjectName',
          },
          {
            label: '收费标准名称',
            prop: 'standardName',
          },
          {
            label: '计费金额',
            prop: 'payTime',
          },
          // {
          //   label: '收费周期',
          //   prop: 'payTime',
          // },
          {
            label: '收费周期',
            prop: 'cycle',
            slot: true,
          },
          {
            label: '开始计费时间',
            prop: 'startTime',
          },
          {
            label: '结束计费时间',
            prop: 'endTime',
          },
          {
            label: '创建人',
            prop: 'createRealName',
          },
        ],
      },
      data: [],
      dicts: {},
      bindTreeLoading:false,
      targetResourceTypeList:[],
      subjectList_:[],
      targetResourceType:'',
      subjectList:[],
      standardDetail:{},
      checkedKeyList:[],
      checkedNodesList:[],
      treeData:{},
      searchForm:{
        standardList:[],
        standardList_:[],
      },
          // label: 'label'
      treeProps: {
        //标题
        label: 'objectFullName',
        //值
        value: 'id',
        //子节点
        // children: 'zones',
      children: 'children',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
    };
  },
  
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      window.addEventListener(
        'resize',
        () => {
          self.$refs.crud.doLayout(); //窗口缩放解决表格错位
        },
        false
      );
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.offlineSum_add, false),
        // viewBtn: this.vaildData(this.permission.offlineSum_view, false),
        delBtn: this.vaildData(this.permission.offlineSum_delete, false),
        editBtn: this.vaildData(this.permission.offlineSum_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    
    this.loadDicts();
    this.initFeeTypeParamList();
    let self = this;
    getAreaZoneList().then((res)=>{
        console.log("getAreaZoneList()=======>",res);
        self.communityList = res.data;
        self.query.communityId = self.communityList[0].id;
        self.communityId = self.communityList[0].id;
        this.showTagetTreeFlag = true;
        // self.lazyLoadPropertyTree();
        getSubjectList().then((resp)=>{
            self.subjectList = resp.data;
            console.log("getSubjectList()=======>",resp);

            getStandardList({communityId:self.communityList[0].id,subjectId:self.subjectList[0].id}).then((response)=>{
                console.log(res);
                self.searchForm.standardList = response.data;
            })
   
            getDictionary('fee_resource_type').then((res) => {
                console.log("getAreaZoneList()=======>",res);
                self.targetResourceTypeList = res.data;


      let arr = [];
      self.targetResourceTypeList.forEach((el,index)=>{
        if(el.dictValue==="房屋"){
          arr.push(el);
        }
      });
      self.targetResourceTypeList = arr;


        self.query.targetResourceType = self.targetResourceTypeList[0].dictKey;
        self.targetResourceType = self.targetResourceTypeList[0].dictKey;
                console.log('this.targetResourceTypeList==========>',self.targetResourceTypeList);
                console.log('self.targetResourceTypeList[0].dictKey======>',self.targetResourceTypeList[0].dictKey);
                getStandardPageList({communityId:self.communityList[0].id,targetResourceType:self.targetResourceTypeList[0].dictKey}).then(({ data })=>{
                    console.log("getStandardPageList()=======>",data);
                    self.showAvueCrudFlag = true;
                    self.page.total = data.total;
                    self.data = data.records;
                    self.loading = false;
                    self.selectionClear();
                })
            });


            
        })
    });
    
  },
  methods: {
    
    loadDicts() {
      //圆整方式,计费方式,定价模式,支付周期,周期单位,账单生成颗粒,违约金起算日期(应收日期),收费精度,算费费率单位,不足月计算方式,不足月天数定义,收费仪表大类,收费仪表小类
      const dictCodes = [
        'fee_standard_round_way',
        'fee_standard_cal_way',
        'fee_standard_pricing_model',
        'fee_standard_cycle_start_rule',
        'fee_standard_cycle_type',
        'fee_standard_cycle_unit',
        'fee_standard_bill_generate_rule',
        'fee_standard_delay_start_type',
        'fee_standard_precision',
        'fee_standard_unit',
        'fee_standard_less_month_way',
        'fee_standard_less_month_days_way',
        'fee_standard_meter_big',
        'fee_standard_meter_big_small',
      ];
      let promises = [];
      dictCodes.forEach((item) => {
        promises.push(getDict({ code: item }));
      });
      Promise.all(promises).then((resArr) => {
        let dicts = {};
        resArr.forEach((item, index) => {
          let key = dictCodes[index];
          dicts[key] = item.data;
        });
        this.dicts = dicts;
        this.disableAddBtn = false;
        console.log('this.dicts==>', this.dicts);
      });
    },
    findDictValue(dictKey, dictData) {
      let res;
      if (!dictKey || !dictData || dictData.length == 0) {
        console.log('emoty==>');
        return '';
      }
      dictData.forEach((item) => {
        if (item.dictKey == dictKey) {
          res = item;
        }
      });
      return res.dictValue || "";
    },
    handleShowCycle(item) {
      try {
        let res = '';
        if(item.feeWay== '99'){
          return ''
        }
        // res += this.findDictValue(item.cycleType, this.dicts.fee_standard_cycle_type);
        if (item.cycleUnit) {
          // res += ':';
          if(item.cycleNum){
            if(parseInt(item.cycleType)==1){
              res += '每';
              res += this.findDictValue(item.cycleUnit, this.dicts.fee_standard_cycle_unit);
              res += '收';
              res += item.cycleNum;
              res += '次';
            }
          }else{
            if(parseInt(item.cycleType)==2){
              res += '一次性收费';
            }
          }
        } else {
          res += item.cycleNum;
        }
        return res;
      } catch (err) {
        console.log('handleShowCycleerr==>', err);
        return '';
      }
    },
    viewData(row){
      console.log(row);
      this.$refs.crud.rowView(row,row.$index)
    },
    subjectChangeHandler(val){
      let self = this;
                self.query = Object.assign({},self.query,{standardId:''});
      self.searchForm.standardList = '';
      console.log("standardChangeHandler(val)================>",val);
      getStandardList({communityId:self.query.communityId,subjectId:self.query.subjectId}).then((response)=>{
          console.log(response);
          console.log(response.data);
          setTimeout(()=>{
            self.searchForm.standardList = this.deepClone(response.data);
            console.log(self.searchForm.standardList);
          })
      })
    },
    
    subjectChangeHandler_(val){
      let self = this;
      self.formStepOne = Object.assign({},self.formStepOne,{standardId:''});
      self.searchForm.standardList_ = '';
      console.log("standardChangeHandler(val)================>",val);
      getStandardList({status:'1',communityId:self.query.communityId,subjectId:self.formStepOne.subjectId}).then((response)=>{
          console.log(response);
          console.log(response.data);
          setTimeout(()=>{
            self.searchForm.standardList_ = this.deepClone(response.data);
            console.log(self.searchForm.standardList_);
          })
      })
    },
    getStandardId(id){
      let self = this;
      let name = '';
      console.log('getStandardId(id)=========>',id);
      console.log('getStandardId(id)=========>',self.searchForm.standardList_);
      self.searchForm.standardList_.forEach((ele,index)=>{
        if(id===ele.id){
          name = ele.name;
        }
      })
      return name;
    },
    getSubjectId(id){
      let name = '';
      this.subjectList.forEach((ele,index)=>{
        if(id===ele.id){
          name = ele.name;
        }
      })
      console.log();
      return name;
    },
    getTargetResourceType(id){
      console.log('getTargetResourceType(id)');
      let name = '';
      this.targetResourceTypeList.forEach((ele,index)=>{
        if(id===ele.dictKey){
          name = ele.dictValue;
        }
      })
      return name;
    },
    finishBind(){
      let arr = this.formStepThreeTableList;
      let self = this;
      batchBind({standardId:self.formStepOne.standardId,bindList:arr}).then((res)=>{
        this.showRoomSelect = false,
        this.$message.success('绑定成功！')
        this.onLoad();
      })
    },
    nodeCheckChange(node,b,c){
      // this.bindTreeLoading = true;
      // console.log("nodeCheckChange(a,b,c){============>",node,b,c);
      // if(node.hasChildren){
      //   this.$refs.standardTreeRef.setChecked(node.id,false,false);
      // }
      // this.checkedKeyList = this.$refs.standardTreeRef.getCheckedKeys();
      // this.checkedNodesList = this.$refs.standardTreeRef.getCheckedNodes();
      // console.log(this.$refs.standardTreeRef.getCheckedNodes());
      
      // this.bindTreeLoading = false;
    },
    toStepThree(){
      let self = this;
      if(!this.formStepTwo.targetResourceType){
        this.$message.error('请选择"费用资源"!');
        return;
      }
      this.checkedKeyList = this.$refs.standardTreeRef.getCheckedKeys();
      this.checkedNodesList = this.$refs.standardTreeRef.getCheckedNodes();
      
      if(this.checkedKeyList.length==0){
        this.$message.error('请选择"房屋"!');
        return;
      }
      let arrKeys = [];
      let arrNodes = []; 
      console.log('this.checkedKeyList,this.checkedNodesList==========>',this.checkedKeyList,this.checkedNodesList);
        self.checkedNodesList.forEach((ele,index)=>{
          if(ele.hasChildren){

          }else{
            arrNodes.push(ele);
            arrKeys.push(ele.id);
          }
        });
      self.formStepThreeTableList = [];
      arrKeys.forEach((ele,index)=>{
        
        self.formStepThreeTableList.push({
          communityId:self.communityId,
          targetId:ele,
          subjectId:self.formStepOne.subjectId,
          standardId:self.formStepOne.standardId,
          targetResourceType:self.formStepTwo.targetResourceType,
          targetName:arrNodes[index].objectFullName,
          startTime:this.standardDetail.startTime,
          endTime:this.standardDetail.endTime,
        })
      });
      console.log(self.formStepThreeTableList);
      checkTreeBind(self.formStepThreeTableList).then((res)=>{
        // console.log(res);
            console.log('this.checkedKeyList==========>',this.checkedKeyList);
            this.activeStep = "3";
            this.formStepOneFlag = false;
            this.formStepTwoFlag = false;
            this.formStepThreeFlag = true;
      })
// return;
    },
    toStepTwo(){
      if(!this.formStepOne.subjectId){
        this.$message.error('请选择"费用科目"!');
        return;
      }
      if(JSON.stringify(this.standardDetail)==="{}"){
        this.$message.error('请选择"收费标准"!');
        return;
      }
      let arr = [];
      this.targetResourceTypeList.forEach((el,index)=>{
        if(el.dictValue==="房屋"){
          arr.push(el);
        }
      });
      this.targetResourceTypeList = arr;

      this.bindTreeLoading = true;
      this.activeStep = "2";
      this.formStepOneFlag = false;
      this.formStepTwoFlag = true;
      this.formStepThreeFlag = false;
      this.showTagetTreeFlag = false;
      this.formStepTwo.targetResourceType = '1';

      console.log('this.formStepOne.standardId=========>',this.formStepOne.standardId);
      
      
      getBindKeys({standardId:this.formStepOne.standardId}).then((res)=>{
        console.log("getBindKeys==========>",res);
        this.defaultKeys = res.data;
        getLazyBasePropertyTree({communityId:this.communityId}).then((res)=>{
          this.treeData = res.data;
          this.showTagetTreeFlag = true;
          this.bindTreeLoading = false;
        });
      });
    },
    nodeExpandHandler(a,b,c){
      console.log("nodeExpandHandler(a,b,c)========>",a,b,c);
    },
    targetResourceTypeChange(val){
      this.targetResourceType = val;
      this.query = Object.assign({},this.query,{targetResourceType:val});
    },
    clearProperty(){
      this.targetName = '';
    },
    standardChange(val){
      console.log("standardChange(val)===========>",val);
      this.formStepOne = Object.assign({},this.formStepOne,{standardId:val});
      console.log("this.formStepOne.standardId=========>",this.formStepOne.standardId);
      getStandardDetail({id:val}).then((res)=>{
        console.log("getStandardDetail({id:val})============>",res.data);
        this.standardDetail = res.data;
      });
    },
    showAddBox(row){
      let self = this;
      this.activeStep = "1";
      this.formStepOneFlag = true;
      this.formStepTwoFlag = false;
      this.formStepThreeFlag = false;
      this.showRoomSelect = true;
      this.formStepOne = {};
      this.formStepTwo = {};
      this.standardDetail = {};
      getSubjectList({status:'1'}).then((resp)=>{
            self.subjectList_ = resp.data;
            console.log("getSubjectList()=======>",resp);
      });
    },
    backStepOne(){
      this.activeStep = "1";
      this.formStepOneFlag = true;
      this.formStepTwoFlag = false;
      this.formStepThreeFlag = false;
    },
      communityChange(val){
          console.log('communityChange(val)==========>',val);
          this.communityId = val;
          this.targetName = '';
          this.query.objectId = '';

          let self = this;
        getSubjectList().then((resp)=>{
            self.subjectList = resp.data;
            console.log("getSubjectList()=======>",resp);

            getStandardList({communityId:self.communityId,subjectId:self.query.subjectId?self.query.subjectId:self.subjectList[0].id}).then((response)=>{
                // console.log(res);
                self.query = Object.assign({},self.query,{standardId:''});
                self.searchForm.standardList = response.data;
            })
   
            getDictionary('fee_resource_type').then((res) => {
                console.log("getAreaZoneList()=======>",res);
                self.targetResourceTypeList = res.data;

      let arr = [];
      self.targetResourceTypeList.forEach((el,index)=>{
        if(el.dictValue==="房屋"){
          arr.push(el);
        }
      });
      self.targetResourceTypeList = arr;
                
                console.log('this.targetResourceTypeList==========>',self.targetResourceTypeList);
                getStandardPageList({communityId:self.communityList[0].id,targetResourceType:self.targetResourceTypeList[0].dictKey}).then((res)=>{
                    console.log("getStandardPageList()=======>",res);
                })
            });


            
        })
          this.showTagetTreeFlag = false;
          setTimeout(()=>{
            this.showTagetTreeFlag = true;
          })
          // this.lazyLoadPropertyTree('','',true)
      },
    //懒加载树结构
    lazyLoadPropertyTree(node, resolve) {
      let id;
      let self = this;
      if (node.level === 0) {
        // getAreaZoneList().then((res)=>{
        //   console.log("getAreaZoneList()=======>",res);
        //   self.communityList = res.data;
        //   // self.communityId = self.communityList[0].id;
          id = self.communityId;
          getTreeChildrenPowerNode({ id: id, power: 1 }).then(({ data }) => {
            // this.treeData = data;
            resolve(data);
          });
        // });
      } else {
        id = node.data.id;
        getTreeChildrenPowerNode({ id: id, power: 1 }).then(({ data }) => {
          // this.treeData = data;
          resolve(data);
        });
      }
    // let id = ;
    },
    nodeTreeCheckClick1(){
      console.log('nodeTreeCheckClick1==================>');
      this.bindTreeLoading = true;
      setTimeout(()=>{
        this.bindTreeLoading = false;
      },4000)
    },
    //点击左侧树结构回调
    propertyNodeTreeClick1(node) {
      console.log('node   2222==>',node);
      this.query.targetId = node[this.treeProps.value];
      this.query.objectId = node[this.treeProps.value];

      this.targetName = node[this.treeProps.label];
    //   if (this.propertyAddShowDialogFlag) {
        this.$refs.propertySelectRef1.blur();
    //   }
    },
    //点击窗口中的父节点选择框回调函数
    nodeAddClickParentNodeSelect() {},
    propertyAddClickParentNodeSelect() {},
      
    // 窗口中父节点树节点点击回调
    nodeAddParentNodeTreeClick(node) {
        
        this.$refs.nodeAddParentNodeSelectRef.blur();
    },
        lazyLoadNodeAddParentNodeTree(){

            loadRoomTree1().then(({ data }) => {
                return resolve(data);
            });

            
            // loadRoomTree2({ id: '1273583963599921154' }).then(({ data }) => {
            //     resolve(data);
            // });
        },

      
      unBindList(){
        let self = this;
          console.log('this.selectionList===========>',this.selectionList);
          if(this.selectionList&&this.selectionList.length>0){
            let arr = [];
            self.selectionList.forEach((ele,index)=>{
              arr.push(ele.id)
              // console.log();
            })
            let ids = arr.join(',')
            console.log("ids==========>",ids);
              this.$confirm(`确定批量解绑?`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
              })
              .then(() => {
                  removeStandard({ids:ids}).then((res)=>{
                      //   console.log(res);
                      this.onLoad();
                  })
              })
              .catch(() => {});
          }
      },
      unBind(row){
            this.$confirm(`确定解绑"${row.targetName}"?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
            .then(() => {
                removeStandard({ids:row.id}).then((res)=>{
                    //   console.log(res);
                    this.onLoad();
                })
            })
            .catch(() => {});
      },
    initFeeTypeParamList() {
      getDictionary('offline_fee_type').then((data) => {
        this.feeTypeParamList = data.data;
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        setTimeout(()=>{
          console.log("this.$refs.crud=============>",this.$refs.crud);
          let val = document.querySelector('div[aria-label="查 看"]').querySelector('input[placeholder="请选择 计费资源类型"]').value
          this.targetResourceTypeList.forEach((ele,index)=>{
            if(val == ele.dictKey){
              document.querySelector('div[aria-label="查 看"]').querySelector('input[placeholder="请选择 计费资源类型"]').value = ele.dictValue
            }
          });
        });
      }
      done();
    },
    searchReset() {
      let self = this;
      this.query = {communityId:self.query.communityId};
      this.targetName = '';
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    selectionChange(list) {
        console.log("selectionChange(list)=======>",list);
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page, params = {}) {
      let self = this;
      page = page || this.page;
      if (params.dateRange) {
        params.dateFrom = params.dateRange[0];
        params.dateTo = params.dateRange[1];
      }else{
        params.dateFrom = '';
        params.dateTo = '';
      }
      this.loading = true;
      // if(!this.showAvueCrudFlag && self.communityId){
      //   this.showAvueCrudFlag = true;
      // }
      getStandardPageList(Object.assign({ current: page.currentPage, size: page.pageSize, communityId:self.communityId,targetResourceType:self.query.targetResourceType ? self.query.targetResourceType:'1' }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
